import gql from 'graphql-tag';

export const MODIFICATION_GROUP_QUERY = gql`
  query getModificationGroup($id: String!) {
    getModificationGroup(id: $id) {
      id
      type
      internalName
      externalName

      preselectedVariations
      variations {
        id
        nameLang {
          en
          se
          es
          no
        }
      }

      required
      expandedByDefault
    }
  }
`;

export const CREATE_MODIFICATION_GROUP = gql`
  mutation CreateModificationGroup($input: ModificationGroupInput!) {
    createModificationGroup(input: $input) {
      success
      error
      message
      id
    }
  }
`;

export const UPDATE_MODIFICATION_GROUP = gql`
  mutation UpdateModificationGroup($input: UpdateModificationGroupInput!) {
    updateModificationGroup(input: $input) {
      success
      error
      message
    }
  }
`;

export const DELETE_MODIFICATION_GROUP = gql`
  mutation DeleteModificationGroup($input: DeleteModificationGroupInput!) {
    deleteModificationGroup(input: $input) {
      success
      error
      message
    }
  }
`;
